import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Calculators from "@/pages/Calculators";
import Book from "@/pages/Book";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import Callback from "@/pages/Callback";
import WhoWeHelp from "@/pages/WhoWeHelp";
import Markets from "@/pages/Markets";
import FinancePage from "@/pages/FinancePage";
import { FINANCE_PAGE_SLUGS } from "@/data/financePages";
import Resources from "@/pages/Resources";
import Article from "@/pages/Article";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-paper text-ink">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-help" element={<WhoWeHelp />} />
            <Route path="/about" element={<About />} />
            <Route path="/calculators" element={<Calculators />} />
            <Route path="/markets" element={<Markets />} />
            <Route path="/book" element={<Book />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<Article />} />
            {FINANCE_PAGE_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<FinancePage slug={slug} />} />
            ))}
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
